import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GENERAL_ERROR_MESSAGE } from '@shared/models/messages';
import { UserManual } from '@features/user-guides/models/user-manual.model';
import { SnackBarService } from '@shared/services/snack-bar.service';

@Injectable({
  providedIn: 'root',
})
export class UserGuideApiService {
  readonly http = inject(HttpClient);
  private _messageService = inject(SnackBarService);
  readonly url = `${environment.apiUrl}/manuals`;

  getUserGuide$(maId: number): Observable<UserManual> {
    return this.http.get<UserManual>(`${this.url}/${maId}`).pipe(
      catchError(error => {
        this._messageService.showError(`Failed to retrieve user guide:  ${error.error.message ?? GENERAL_ERROR_MESSAGE}.`);
        return of();
      })
    );
  }

  updateUserGuide$(updatedUserManual: UserManual): Observable<UserManual> {
    return this.http.put<UserManual>(`${this.url}/${updatedUserManual.maId}`, updatedUserManual).pipe(
      tap(() => {
        this._messageService.showInfo('User guide updated successfully.');
      })
    );
  }
}
